import React from "react";
import equal from "fast-deep-equal/es6";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";

import { appStore, observeStore } from "../../../stores";
import { BaseListModule } from "../BaseListModule";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import { JsonLoader } from "./JsonLoader";
import { JsonModuleListItem } from "./JsonModuleListItem";

@observer
export class JsonModule extends BaseListModule<"json"> {
    private jsonLoader = JsonLoader.get();
    protected type: "json" = "json";

    componentWillUnmount() {
        JsonLoader.release(this.jsonLoader);
    }

    protected listItem = (point: IMetadataDataPoint<"json">, i: number) => {
        const {
            selected: selectedDataPoint,
            onClick,
            onClose,
            jsonLoader,
        } = this;
        const { hideDevice } = this.props;
        const { mode, time } = observeStore;

        const selected =
            // When paused, the selected row is the clicked row.
            (mode === "pause" && equal(selectedDataPoint, point)) ||
            // When not paused, the selected row is the first row
            // (but only if activated by selecting any row first).
            (mode !== "pause" && i === 0 && !!selectedDataPoint);

        return (
            <JsonModuleListItem
                key={i}
                point={point}
                old={
                    point.time.getTime() < time.getTime() - 5 * duration.second
                }
                live={mode === "live"}
                hideDevice={hideDevice}
                utc={appStore.utc}
                onClick={onClick}
                onClose={onClose}
                selected={selected}
                jsonLoader={jsonLoader}
            />
        );
    };

    @observable
    private selected: IMetadataDataPoint<"json"> | undefined = undefined;

    private onClick = (point: IMetadataDataPoint<"json">) => {
        // Toggle row selection when clicked - except if there is selected text
        if (window.getSelection()?.type === "Range") {
            return;
        }
        this.selected = equal(this.selected, point) ? undefined : point;
        observeStore.mode = "pause";
    };

    private onClose = () => {
        this.selected = undefined;
    };
}
